export function friendlyVideoError(msg: string | null | undefined): string {
  if (!msg) return 'Unknown error occurred.';
  // Service/key-permission failures come first — their raw Google message also
  // contains "blocked", and the safety copy ("rephrase the prompt") sends users
  // down a futile path when the video API itself is unavailable (F-055).
  if (/VIDEO_SERVICE_BLOCKED|API_KEY_SERVICE_BLOCKED|SERVICE_DISABLED/i.test(msg))
    return 'Video generation is temporarily unavailable for this account — your prompt is fine. We are on it; try again later.';
  if (/VIDEO_SAFETY_BLOCK/i.test(msg) || /safety.?block|blocked.*policy|prohibited/i.test(msg))
    return 'Blocked by Veo safety filter — try rephrasing the prompt or swapping the source image.';
  if (/VIDEO_VERTEX_BAD_REQUEST/i.test(msg)) {
    const reasonMatch = msg.match(/VIDEO_VERTEX_BAD_REQUEST[^:]*:\s*(.+)/i);
    const reason = reasonMatch?.[1]?.trim();
    if (reason && /MIME|jpeg|png/i.test(reason)) {
      return 'Source image must be JPEG or PNG — convert and retry.';
    }
    if (reason) return `Veo rejected the request: ${reason}`;
    return 'Veo rejected the request. Check the source image format and aspect ratio.';
  }
  if (/VIDEO_VERTEX_OP_ERROR/i.test(msg)) {
    const reasonMatch = msg.match(/VIDEO_VERTEX_OP_ERROR:\s*(.+)/i);
    const reason = reasonMatch?.[1]?.trim();
    return reason ? `Veo error: ${reason}` : 'Veo returned an error — try again.';
  }
  if (/VIDEO_EMPTY_NO_SIGNAL/i.test(msg)) {
    return 'Veo returned no video. Often caused by an unsupported aspect ratio (must be 16:9 or 9:16) or duration mismatch with reference images. Adjust and retry.';
  }
  if (/NoVideoGenerated|no video bytes/i.test(msg))
    return 'Generation failed — Veo may be busy. Try again.';
  if (/timeout|AbortSignal|exceeded/i.test(msg))
    return 'Timed out — try a shorter duration or lower resolution.';
  if (/upload.*failed|storage.*failed/i.test(msg)) return 'Upload failed — please try again.';
  if (/auto-recovered by maintenance sweep/i.test(msg))
    return 'Generation timed out — please try again.';
  return 'Video generation failed — please try again.';
}
